import {Module} from 'vuex';
import {RootState} from '@/types';
import RoleAPI from '@/api/RoleAPI';
import {SET_ROLE, SET_ROLES} from '@/store/mutationTypes';
import {namespace} from 'vuex-class';
import {Permission} from '@/store/modules/permissions';

export const rolesModule = namespace('roles');

export interface Role {
  id: number | string | null;
  name: string;
  description: string;
  permissions?: Permission[];

  [key: string]: any;
}

interface RoleState {
  roles: Role[];
  role: Role | null;
}

export default <Module<RoleState, RootState>>{
  namespaced: true,
  state: {
    roles: [],
    role: null,
  },
  mutations: {
    [SET_ROLES](state, data) {
      state.roles = data;
    },
    [SET_ROLE](state, data) {
      state.role = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await RoleAPI.all(params);
        if (!!params.paginate) {
          commit(SET_ROLES, data.data);
        } else {
          commit(SET_ROLES, data.data.data);
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await RoleAPI.detail(id);
        commit(SET_ROLE, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async create(_, payload) {
      try {
        const {data} = await RoleAPI.create(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async update(_, {id, data: payload}) {
      try {
        const {data} = await RoleAPI.update(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async delete(_, id) {
      try {
        const {data} = await RoleAPI.delete(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
  getters: {},
};
